import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PlatformService } from '@services/platform.service';


export const mobileAppCanActivate: CanActivateFn = (): boolean | UrlTree => {
  const platformService = inject(PlatformService);

  if (platformService.isDevice) {
    return true;
  } else {
    return inject(Router).createUrlTree(['/avatar']);
  }
};
